import { useContext } from 'react';
import TabBarContext from '../TabBarContext';

export default function useIsTabSelected(value: any)
{
    return useContext(TabBarContext) === value;
}
